import React, { useState } from 'react';
import { X, Tag } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-[#fef3e2] border-b border-[#b87333]/20 relative z-50" data-id="element-141">
      <div className="max-w-7xl mx-auto px-4 py-2.5 sm:py-3 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-sm sm:text-base" data-id="element-142">
        <div className="flex items-center gap-2 text-[#b87333] font-semibold text-center" data-id="element-143">
          <Tag className="w-4 h-4 sm:w-5 sm:h-5 animate-pulse" data-id="element-144" />
          <span data-id="element-145">🎉 LIMITED TIME: Get $50 OFF Your First Service!</span>
        </div>
        <a href="#coupon" onClick={e => {
        const el = document.getElementById('coupon');
        if (el) {
          e.preventDefault();
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }} className="bg-[#b87333] hover:bg-[#a0632a] text-white px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold transition-colors shadow-sm whitespace-nowrap" data-id="element-146">
          Claim Discount
        </a>
        <button onClick={() => setIsVisible(false)} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-[#b87333]/60 hover:text-[#b87333] transition-colors" aria-label="Dismiss promo" data-id="element-147">
          <X className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-148" />
        </button>
      </div>
    </div>;
}